// Mock data for technical services page

export const companyInfo = {
  name: "TecnoService",
  tagline: "Reparación Profesional de Electrodomésticos",
  phone: "+57 322 688 2325",
  whatsapp: "573226882325",
  email: "tecnoservice2001@gmail.com",
  address: "Medellín, Antioquia",
  hours: "24 Horas"
};

export const services = [
  {
    id: 1,
    title: "Neveras y Refrigeradores",
    description: "Reparación y mantenimiento de todo tipo de neveras y refrigeradores. Diagnóstico rápido y soluciones efectivas.",
    icon: "Refrigerator",
    image: "https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&q=85"
  },
  {
    id: 2,
    title: "Lavadoras",
    description: "Servicio técnico especializado en lavadoras de todas las marcas. Reparación de motores, tambores y sistemas electrónicos.",
    icon: "WashingMachine",
    image: "https://images.unsplash.com/photo-1632923565835-6582b54f2105?crop=entropy&cs=srgb&fm=jpg&q=85"
  },
  {
    id: 3,
    title: "Secadoras",
    description: "Mantenimiento y reparación de secadoras. Solución a problemas de calentamiento y sistemas de ventilación.",
    icon: "Wind",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/6bhp92c8_IMG-20260401-WA0025%281%29.jpg"
  },
  {
    id: 4,
    title: "Microondas",
    description: "Reparación de microondas con garantía. Solución a problemas eléctricos y de magnetrón.",
    icon: "Microwave",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/gpotj08w_IMG-20260401-WA0026.jpg"
  },
  {
    id: 5,
    title: "Campanas Extractoras",
    description: "Instalación, reparación y mantenimiento de campanas extractoras. Limpieza profunda de filtros.",
    icon: "Fan",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/rrx5id0k_IMG-20260401-WA0027.jpg"
  },
  {
    id: 6,
    title: "Calentadores",
    description: "Servicio técnico para calentadores eléctricos y a gas. Revisión de sistemas de seguridad.",
    icon: "Flame",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/mvpkgldn_IMG-20260401-WA0028.jpg"
  },
  {
    id: 7,
    title: "Cubiertas y Estufas",
    description: "Reparación de cubiertas eléctricas y a gas. Mantenimiento de quemadores y controles.",
    icon: "Flame",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/7xgkwdvr_IMG-20260401-WA0029.jpg"
  },
  {
    id: 8,
    title: "Bafles",
    description: "Reparación de bafles y sistemas de sonido. Diagnóstico profesional y solución de problemas de audio.",
    icon: "Speaker",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/iot6p3de_IMG-20260401-WA0030.jpg"
  },
  {
    id: 9,
    title: "Aire Acondicionado",
    description: "Instalación, mantenimiento y reparación de aires acondicionados. Limpieza y recarga de gas.",
    icon: "Wind",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/8db9xnwg_IMG-20260401-WA0031.jpg"
  },
  {
    id: 10,
    title: "Hornos",
    description: "Reparación de hornos eléctricos y a gas. Mantenimiento de resistencias y termostatos.",
    icon: "Flame",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/ytx7thmz_IMG-20260401-WA0032.jpg"
  },
  {
    id: 11, // Last service ID
    title: "Congeladores",
    description: "Servicio técnico para congeladores horizontales y verticales. Reparación de sistemas de refrigeración.",
    icon: "Refrigerator",
    image: "https://customer-assets.emergentagent.com/job_tech-solutions-hub-100/artifacts/501033hr_IMG-20260401-WA0033.jpg"
  }
];

export const features = [
  {
    id: 1,
    title: "Técnicos Certificados",
    description: "Personal altamente calificado con años de experiencia",
    icon: "BadgeCheck"
  },
  {
    id: 2,
    title: "Servicio Rápido",
    description: "Respuesta inmediata y soluciones eficientes",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Garantía",
    description: "Todos nuestros servicios incluyen garantía",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Repuestos Originales",
    description: "Usamos solo repuestos de calidad garantizada",
    icon: "Package"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    text: "Excelente servicio, repararon mi nevera en menos de 24 horas. Muy profesionales.",
    rating: 5,
    platform: "Google"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    text: "Resolvieron el problema de mi lavadora rápidamente. Precios justos y trabajo de calidad.",
    rating: 5,
    platform: "Facebook"
  },
  {
    id: 3,
    name: "Ana Martínez",
    text: "Servicio confiable y técnicos muy amables. Los recomiendo completamente.",
    rating: 5,
    platform: "Google"
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Cuánto tiempo tarda una reparación?",
    answer: "La mayoría de reparaciones se completan el mismo día. En casos especiales que requieren repuestos, puede tomar 2-3 días."
  },
  {
    id: 2,
    question: "¿Ofrecen garantía en sus servicios?",
    answer: "Sí, todos nuestros servicios incluyen garantía de 90 días en mano de obra y repuestos."
  },
  {
    id: 3,
    question: "¿Cuáles son sus formas de pago?",
    answer: "Aceptamos efectivo, tarjetas de crédito/débito y transferencias bancarias."
  }
];
